import './index.scss';

const ContactLetters =()=> {
    return (
        <h2 id="contact-header">Contact me</h2>
    )
};

export default ContactLetters
